module.exports = __webpack_public_path__ + "images/icons/icon-step-shipping-d8f93308.svg";